'use strict';

var _ = require('../dependency')._,
    config = require('../config'),
    $u = require('../utilities'),
    chartTypes = require('./chartTypes');

var GRAPHS = config.graphs,
    $d = config.druid;

var chartId = 'NEW_CUSTOMER_TREND',
    dataSeries = {
        TIMESTAMP: 'timestamp',
        CUSTOMERS: 'customers'
    },
    fieldNames = {
        CUSTOMERS: 'numOfNewCustomers'
    },
    /**
     * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
     * can be modified for other data provider systems.]
     * @type {Object}
     */
    dataConfig = [{
        queryType: 'timeseries',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbageCustomer',
        /*above Can be set in library matrix charts*/
        aggregations: [{
            'type': 'longSum',
            'name': dataSeries.CUSTOMERS,
            'fieldName': fieldNames.CUSTOMERS
        }]
    }];

module.exports = chartTypes.trendCharts.createConfig({
    chartId: chartId,
    dataSeries: dataSeries,
    fieldNames: fieldNames,
    dataConfig: dataConfig,
    chartTemplate: chartTemplate,
    averageTask: false
});

function chartTemplate(data, width) {
    width = parseInt(width.match(/\d+/g)[0], 10);
    var duration = data.__duration,
        granularity = data.__granularity,
        xAxisLabelOffset = $u.charts.getXaxisOffset(duration),
        x = xAxisLabelOffset.x,
        y = xAxisLabelOffset.y,
        legendAdjustments = $u.charts.getLegendAdjustments(duration, false, false),
        pointWidth = width / 50;

    var yAxisBaseUnit = '',
        yAxisRoundOff = false,
        xAxisFormatter = $u.charts.generateXaxisDaysData,
        yAxisFormatter = $u.charts.chartYaxisFormatter,
	yAxisTrimDecimalPlaces = 2;


    var chartTemplateObj = {
        dataTableConfig: {
            duration: duration,
            granularity: granularity,
            xAxisFormatter: xAxisFormatter,
            yAxisFormatter: yAxisFormatter,
            yAxisBaseUnit: yAxisBaseUnit,
            yAxisRoundOff: yAxisRoundOff,
            xAxisDataHeader: 'Dates'
        },
        chart: {
            type: 'column',
            zoomType: 'x,y',
            alignTicks: false,
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM,
            events: {
                load: function() {
                    var dataUnit,
                        chartContext = this,
                        dataArray;

                    _.forEach(chartContext.yAxis, function(yAxisObject) {
                        dataArray = [];
                        dataUnit = ' ';
                        _.forEach(yAxisObject.series, function(seriesItem) {
                            dataArray.push(seriesItem.dataMax);
                        });
                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), '').unit;
                        yAxisObject.setTitle({
                            text: data.i18n.YAXIS_TEXT + ' ' + dataUnit
                        });
                    });
                }
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function() {
                var that = this,
                    tooltipUnitObj = yAxisFormatter(that.y, that.series.dataMax, yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces);

                return $u.charts.sformat('{0}<br>{1}: <b>{2} {3}</b>',
                    xAxisFormatter(duration, granularity, this.x),
                    this.series.name,
                    tooltipUnitObj.value,
                    tooltipUnitObj.unit);
            },
            valueDecimals: 0
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance
        },
        xAxis: {
            categories: data[dataSeries.TIMESTAMP],
            tickmarkPlacement: 'on',
            labels: {
                step: function() {
                    if (data.timestamp) {
                        return data.timestamp.length >=
                            GRAPHS.GLOBAL.MAX_XAXIS_LABELS ? 2 : 1;
                    }
                }(),
                rotation: -45,
                align: 'center',
                x: x,
                y: y,
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                formatter: function() {
                    return xAxisFormatter(duration, granularity, this.value);
                },
                useHTML: true,
                autoTransform: true
            }
        },
        yAxis: [{
            allowDecimals: false,
            title: {
                text: '',
                style: {
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                }
            },
            labels: {
                format: '{value}',
                formatter: function() {
                    var that = this,
                        yAxisValue = that.value,
                        yMaxValue = that.axis.dataMax;
                        
                    return yAxisFormatter(yAxisValue, yMaxValue,
                        yAxisBaseUnit, yAxisRoundOff).value;
                },
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                x: -20
            },
            maxPadding: 0,
            lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
            lineWidth: 1
        }],
        plotOptions: {
            column: {
                stacking: false,
                dataLabels: {
                    enabled: false,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_OFF_WHITE
                }
            },
            series: {
                pointWidth: pointWidth
            }
        },
        series: [{
            showInLegend: false,
            name: 'New Customers',
            data: data[dataSeries.CUSTOMERS],
            color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
            borderColor: GRAPHS.GLOBAL.COLORS.MOJO_BLUE
        }]
    };
    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}
